<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="ngxDisabled" [(ngModel)]="selectedClusters" placeholder="Venta" (select)="changeCluster($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>